// client/src/pages/ResultsDashboard.js
import React, { useState } from 'react';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Button, Card, CardContent, CardHeader, FormControl, GlobalStyles, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import ChartsDashboard from './results-v2/components/ChartsDashboard';
import PrintLayout from './results-v2/components/PrintLayout';
import useResultsV2Logic from './results-v2/useResultsV2Logic';
import { PRINT_WINDOW_CSS } from './results-v2/components/PrintLayout';

const PRINT_SECTIONS = [
  { value: 'all', label: 'All Sections' },
  { value: 'events', label: 'Events Only' },
  { value: 'division', label: 'Division Only' },
  { value: 'category', label: 'Category Only' },
  { value: 'overall', label: 'Overall Only' },
];

const PRINT_STYLES = {
  '@media print': {
    '.no-print': { display: 'none !important' },
  },
};

const ResultsDashboard = () => {
  const [printSection, setPrintSection] = useState('all');

  const {
    adjustedTeamsMap,
    eventsScores,
    eventsMap,
    teams,
    categoriesMap,
    divisionsMap,
    adjustedRows,
  } = useResultsV2Logic();

  const handlePrint = () => {
    const el = document.querySelector('.print-layout');
    if (!el) return;
    const win = window.open('', '_blank');
    win.document.write(`<!DOCTYPE html><html><head><title>AMC Results</title>
<style>${PRINT_WINDOW_CSS}</style></head><body>${el.innerHTML}</body></html>`);
    win.document.close();
    win.print();
  };

  return (
    <>
      <GlobalStyles styles={PRINT_STYLES} />

      <Grid2 className="no-print" sx={{ p: 3 }}>
        <Card variant="outlined" sx={{ mb: 3 }}>
          <CardHeader
            title="Print Results"
            subheader="Print award ceremony sheets in order: Events → Division → Category → Overall"
          />
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="center">
              <FormControl variant="standard" sx={{ minWidth: 220 }}>
                <InputLabel>Section</InputLabel>
                <Select value={printSection} onChange={e => setPrintSection(e.target.value)}>
                  {PRINT_SECTIONS.map(s => (
                    <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="contained"
                startIcon={<PrintIcon />}
                onClick={handlePrint}
              >
                Print
              </Button>
            </Stack>
          </CardContent>
        </Card>

        <Box sx={{ mb: 2 }}>
          <Typography variant="h5">Dashboard</Typography>
        </Box>

        <ChartsDashboard
          adjustedTeamsMap={adjustedTeamsMap}
          eventsScores={eventsScores}
          eventsMap={eventsMap}
          teams={teams}
          categoriesMap={categoriesMap}
          divisionsMap={divisionsMap}
          adjustedRows={adjustedRows}
        />
      </Grid2>

      <PrintLayout
        eventsScores={eventsScores}
        adjustedTeamsMap={adjustedTeamsMap}
        categoriesMap={categoriesMap}
        divisionsMap={divisionsMap}
        section={printSection}
      />
    </>
  );
};

export default ResultsDashboard;
